// extracted by mini-css-extract-plugin
module.exports = {"confirmOverlay":"AccionaConfirm_confirmOverlay__SkMZi","confirmBox":"AccionaConfirm_confirmBox__3LGDD","footer":"AccionaConfirm_footer__2-h_i"};